export const PEOPLE_CARD_MODAL_OPEN_SET_VALUE = `pubWeb/peopleCardModal/setValue/isOpen`;
export const PEOPLE_CARD_MODAL_CONTENT_SET_VALUE = `pubWeb/peopleCardModal/setValue/content`;

export const setPeopleCardModalIsOpen = value => ({ type: PEOPLE_CARD_MODAL_OPEN_SET_VALUE, value });
export const setPeopleCardModalContent = value => ({ type: PEOPLE_CARD_MODAL_CONTENT_SET_VALUE, value });
